export class ConnectionFailedError extends Error {}
